import { Factory, association } from 'miragejs'
import { faker } from '@faker-js/faker'

export default Factory.extend({
  startsAt() {
    return faker.date.recent({ days: 30 })
  },

  expiresAt() {
    return faker.date.soon({ days: 30 })
  },

  collection: association(),
})
